import { useCallback, useState, useEffect } from 'react';
import React from 'react';
import styles from './CookieBanner.module.scss';

export const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  const setCookie = useCallback((name, value, days) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
  }, []);

  const getCookie = useCallback((name) => {
    return document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${name}=`))
      ?.split('=')[1];
  }, []);

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  useEffect(() => {
    if (!isMounted) return;

    const hasConsent = getCookie('cookies_policy');
    if (!hasConsent) {
      const timer = setTimeout(() => setShowBanner(true), 3000);
      return () => clearTimeout(timer);
    }
  }, [getCookie, isMounted]);

  const handleAccept = useCallback(() => {
    setCookie('cookies_policy', 'true', 365);
    setShowBanner(false);
  }, [setCookie]);

  if (!showBanner) return null;

  return (
    <div
      id="cookiebanner"
      className={styles.bannerWrapper}
      role="dialog"
      aria-label="Cookie consent"
      aria-modal="true"
    >
      <p className={styles.description}>
        Мы используем cookie для обеспечения работы сайта и повышения удобства
        работы с ним. Продолжая пользоваться сайтом, вы соглашаетесь с
        использованием cookie.
      </p>

      <div className={styles.buttonContainer}>
        <button
          className={styles.acceptButton}
          onClick={handleAccept}
          aria-label="Принять использование cookies"
        >
          Принять
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
